export default "__VITE_ASSET__DWAe_78f__"